import { createContext } from 'react';
import { IOpenWidgetWithRecommendationsParams } from '../../types/microfrontends/newbuildingCallbackWidget';

/* istanbul ignore next */
export const NewbuildingCallbackWidgetContext = createContext<
  (params: IOpenWidgetWithRecommendationsParams) => Promise<void>
>(() => Promise.resolve());
